export default __webpack_public_path__ + "static/media/PL.5d4298b1.svg";